import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    X,
    Shield,
    CreditCard,
    TrendingUp,
    MessageCircle,
    Calculator,
    Receipt,
    Plus,
    Target,
    FileText,
} from "lucide-react";

const AppsSlideMenu = ({ showAppsMenu, setShowAppsMenu }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Apps menu items
    const appsMenuItems = [
        {
            id: "consultas",
            icon: MessageCircle,
            label: "Consultas",
            path: "/consultas",
            description: "Asesoría financiera",
            color: "bg-blue-500",
        },
        {
            id: "polizas",
            icon: Shield,
            label: "Pólizas",
            path: "/polizas",
            description: "Seguros y protección",
            color: "bg-indigo-500",
        },
        {
            id: "tarjetas",
            icon: CreditCard,
            label: "Tarjetas",
            path: "/cards",
            description: "Solicitud de tarjetas",
            color: "bg-blue-500",
        },
        {
            id: "cashback",
            icon: CreditCard,
            label: "Cashback Pro",
            path: "/cashback",
            description: "Recompensas",
            color: "bg-purple-500",
            badge: "PRO",
        },
        {
            id: "inversiones",
            icon: TrendingUp,
            label: "Inversiones",
            path: "/inversiones",
            description: "Portfolio",
            color: "bg-green-500",
        },
        {
            id: "ingresos",
            icon: Plus,
            label: "Ingresos",
            path: "/ingresos",
            description: "Entradas de dinero",
            color: "bg-emerald-500",
        },
        {
            id: "gastos",
            icon: Receipt,
            label: "Gastos",
            path: "/gastos",
            description: "Control de gastos",
            color: "bg-red-500",
        },
        {
            id: "calculadora",
            icon: Calculator,
            label: "Calculadora",
            path: "/calculadora",
            description: "Herramientas",
            color: "bg-orange-500",
        },
        {
            id: "metas",
            icon: Target,
            label: "Metas",
            path: "/metas",
            description: "Objetivos financieros",
            color: "bg-pink-500",
        },
        {
            id: "reportes",
            icon: FileText,
            label: "Reportes",
            path: "/reportes",
            description: "Análisis detallado",
            color: "bg-cyan-500",
        },
    ];

    return (
        <>
            {/* Apps Menu - Slide down from top */}
            <div
                className={`fixed left-0 right-0 top-16 lg:top-18 z-40 transform transition-all duration-500 ease-in-out ${showAppsMenu
                    ? "translate-y-0 opacity-100"
                    : "-translate-y-full opacity-0"
                    }`}
            >
                <div className="bg-[#033937] text-white px-4 py-6 shadow-2xl">
                    <div className="container mx-auto">
                        {/* Header */}
                        <div className="flex items-center justify-between mb-6">
                            <div>
                                <h3 className="text-lg font-bold text-white">Apps MiguelMX</h3>
                                <p className="text-sm text-white/70">
                                    Todas tus herramientas financieras
                                </p>
                            </div>
                            <button
                                onClick={() => setShowAppsMenu(false)}
                                className="p-2 hover:bg-white/10 rounded-lg transition-colors"
                            >
                                <X className="w-6 h-6 text-white" />
                            </button>
                        </div>

                        {/* Apps Grid */}
                        <div className="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-9 gap-6">
                            {appsMenuItems.map((app) => {
                                const Icon = app.icon;
                                const isActive = location.pathname.startsWith(app.path);
                                return (
                                    <button
                                        key={app.id}
                                        onClick={() => {
                                            navigate(app.path);
                                            setShowAppsMenu(false);
                                        }}
                                        className={`group flex flex-col items-center p-4 rounded-xl transition-all duration-300 hover:scale-105 ${isActive
                                            ? "bg-[#5ec400] shadow-lg"
                                            : "hover:bg-white/10"
                                            }`}
                                    >
                                        <div
                                            className={`relative w-12 h-12 rounded-xl flex items-center justify-center mb-3 transition-all ${isActive
                                                ? "bg-white/20 shadow-lg"
                                                : `${app.color} group-hover:shadow-lg`
                                                }`}
                                        >
                                            <Icon
                                                className={`w-6 h-6 ${isActive ? "text-white" : "text-white"
                                                    }`}
                                            />
                                            {app.badge && (
                                                <span className="absolute -top-2 -right-2 bg-[#5ec400] text-white text-xs px-2 py-1 rounded-full font-bold">
                                                    {app.badge}
                                                </span>
                                            )}
                                        </div>
                                        <span
                                            className={`text-sm font-semibold text-center ${isActive ? "text-white" : "text-white/90"
                                                }`}
                                        >
                                            {app.label}
                                        </span>
                                        <span className="text-xs text-white/60 text-center mt-1">
                                            {app.description}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>

                        {/* Footer */}
                        <div className="text-center mt-6 pt-4 border-t border-white/20">
                            <p className="text-xs text-white/60">
                                MiguelMX® • Fintech 100% Mexicana
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AppsSlideMenu;